import React from 'react';

import './AdZone.scss';

export default function AdZone(props) {
  return <div id={props.id} className="adlib-zone" {...props.params} />;
}
